(function () {
    'use strict';

    angular
        .module('app')
        .component('nivelEducativoListAdmin', {
            templateUrl: 'app/components/auladigital/admin/niveleducativo/nivel-educativo-list.admin.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                permisos: '<'
            }
        });

    /* @ngInject */
    function Controller($stateParams, NgTableParams, NgTableHelper,
                        ModalService, NivelEducativo, NG_TABLE_DEFAULT_PARAMS) {
        var vm = this;

        vm.item = NivelEducativo;
        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.filter = {};
        vm.tableParams = new NgTableParams({
            count: NG_TABLE_DEFAULT_PARAMS.size,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {orden: 'asc'}
        }, NgTableHelper.settings(vm));

        // Eliminar
        vm.showRemoveConfirmation = function (id) {
            ModalService.open({
                    templateUrl: 'app/components/form/delete/entity.delete.modal.html',
                    controller: 'EntityDeleteModalController',
                    controllerAs: 'ctrl',
                    resolve: {
                        /* @ngInject */
                        item: function (NivelEducativo) {
                            return NivelEducativo.get({id: id}).$promise;
                        },
                        params: function () {
                            return {
                                title: 'aulaDigital.nivelEducativo.admin.delete.title',
                                body: 'aulaDigital.nivelEducativo.admin.delete.confirm',
                                property: 'nombre'
                            };
                        }
                    }
                }
            ).result.then(function () {
                vm.tableParams.reload();
            });
        };
    }

})();
